<!-- <ng-component class="c-container"> -->
  <div class="row">
    <div class="col-12 p-0">
      <img class="icon-close pr-10" src="assets/icons/ico-close.png" alt="cerrar" (click)="firstAction()">
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h1 class="c-titulo-dialogo">{{data.title}}</h1>
      <h2 class="c-titulo-dialogoSub">{{data.subTitle}}</h2>
      <mat-dialog-content class="c-titulo-subtitulo" [innerHtml]="data.description"></mat-dialog-content>
    </div>
  </div>

    <div class="row auto">
      <mat-dialog-actions class=" col-sm-12 col-md-6 auto">
        <button class="btn-secondary-tbk mx-auto" (click)="firstAction()">{{data.textFirstBtn}}</button>

      </mat-dialog-actions>
      <mat-dialog-actions class="col-sm-12 col-md-6 dis auto">
        <button class="btn-primary-tbk mx-auto" (click)="secondAction()" [disabled]="data.disableSecondBtn">{{data.textSecondBtn}}</button>
      </mat-dialog-actions>
    </div>

<!-- </ng-component> -->
